import { useState } from 'react'
import { Icon, type IconName } from '../../components/icons/Icon'
import { Popover } from './Popover'

export interface RowAction {
  id: string
  label: string
  icon?: IconName
  onSelect: () => void
}

export interface RowActionsMenuProps {
  label: string
  actions: RowAction[]
}

/** The per-row kebab menu — every item here must be a real route or a defined action. */
export function RowActionsMenu({ label, actions }: RowActionsMenuProps) {
  const [open, setOpen] = useState(false)
  return (
    <Popover
      label={label}
      open={open}
      onOpenChange={setOpen}
      width={200}
      align="end"
      triggerClassName="iw-icon-btn-sm"
      triggerContent={
        <>
          <Icon name="more-vertical" size={14} />
          <span className="iw-visually-hidden">{label}</span>
        </>
      }
    >
      <ul role="menu" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {actions.map((action) => (
          <li key={action.id} role="none">
            <button
              type="button"
              role="menuitem"
              className="iw-btn iw-btn--ghost iw-btn--sm"
              style={{ width: '100%', justifyContent: 'flex-start' }}
              onClick={() => {
                action.onSelect()
                setOpen(false)
              }}
            >
              {action.icon ? <Icon name={action.icon} size={13} /> : null}
              {action.label}
            </button>
          </li>
        ))}
      </ul>
    </Popover>
  )
}
